import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { MessageService } from 'primeng/api';
import { Intervento } from '../../../models/intervento.model';
import { InterventiService } from '../../../services/interventi.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-modifica-note-intervento',
  templateUrl: './modifica-note-intervento.component.html',
  styleUrls: ['./modifica-note-intervento.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    InputTextareaModule,
    ToastModule,
    RippleModule
  ],
  providers: [MessageService]
})
export class ModificaNoteInterventoComponent {
  @Input() visible: boolean = false;
  @Input() intervento: Intervento | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() noteModificate = new EventEmitter<void>();

  noteOriginali: string | null = null;
  noteCorrente: string | null = null;
  submitting: boolean = false;

  constructor(
    private interventiService: InterventiService,
    private messageService: MessageService,
    private logger: NGXLogger
  ) {}

  show(intervento: Intervento): void {
    this.intervento = intervento;
    this.noteOriginali = intervento.note || null;
    this.noteCorrente = intervento.note || null;
    this.visible = true;
  }

  hide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.reset();
  }

  reset(): void {
    this.intervento = null;
    this.noteOriginali = null;
    this.noteCorrente = null;
    this.submitting = false;
  }

  salva(): void {
    if (!this.intervento || !this.intervento.id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Intervento non valido'
      });
      return;
    }

    // Verifica se le note sono state modificate
    const noteFinali = this.noteCorrente?.trim() || null;
    
    if (noteFinali === this.noteOriginali || 
        (noteFinali === null && (this.noteOriginali === null || this.noteOriginali === ''))) {
      this.messageService.add({
        severity: 'info',
        summary: 'Nessuna modifica',
        detail: 'Le note non sono state modificate'
      });
      this.hide();
      return;
    }

    this.submitting = true;
    this.logger.info('[MODIFICA NOTE] Aggiornamento note per intervento ID:', this.intervento.id);
    this.logger.info('[MODIFICA NOTE] Note originali:', this.noteOriginali);
    this.logger.info('[MODIFICA NOTE] Note modificate:', noteFinali);

    // Aggiorna le note nell'oggetto intervento
    const interventoAggiornato: Intervento = {
      ...this.intervento,
      note: noteFinali
    };

    this.interventiService.modifica(interventoAggiornato).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Note aggiornate',
          detail: 'Le note dell\'intervento sono state aggiornate con successo'
        });
        this.noteModificate.emit();
        this.hide();
      },
      error: (error) => {
        this.logger.error('[MODIFICA NOTE] Errore durante l\'aggiornamento delle note:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore durante l\'aggiornamento delle note'
        });
        this.submitting = false;
      },
      complete: () => {
        this.submitting = false;
      }
    });
  }

  get noteNonModificate(): boolean {
    const noteFinali = this.noteCorrente?.trim() || null;
    return noteFinali === this.noteOriginali || 
           (noteFinali === null && (this.noteOriginali === null || this.noteOriginali === ''));
  }
}
